import { render, staticRenderFns } from "./WorkIconCalendar.vue?vue&type=template&id=6ac905c4"
import script from "./WorkIconCalendar.vue?vue&type=script&lang=js"
export * from "./WorkIconCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports